import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {createRequestFunction, DUMMY_BASE_URL, setSearchParams, toPathString} from '../common';
import {ActCodes} from '../types/actCode';

/**
 * MenuServiceApi - axios parameter creator
 * @export
 */
export const MenuServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 查询菜单数据
     * @summary 查询菜单数据
     * @param {string} [orgId]
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    menuServiceFindMenu: async (
      orgId?: string,
      userId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/menu/menus`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MenuServiceApi - functional programming interface
 * @export
 */
export const MenuServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MenuServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 查询菜单数据
     * @summary 查询菜单数据
     * @param {string} [orgId]
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async menuServiceFindMenu(
      orgId?: string,
      userId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActCodes>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.menuServiceFindMenu(
        orgId,
        userId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MenuServiceApi.menuServiceFindMenu']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MenuServiceApi - factory interface
 * @export
 */
export const MenuServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MenuServiceApiFp(configuration);
  return {
    /**
     * 查询菜单数据
     * @summary 查询菜单数据
     * @param {string} [orgId]
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    menuServiceFindMenu(orgId?: string, userId?: string, options?: any): AxiosPromise<ActCodes> {
      return localVarFp
        .menuServiceFindMenu(orgId, userId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * MenuServiceApi - object-oriented interface
 * @export
 * @class MenuServiceApi
 * @extends {BaseAPI}
 */
export class MenuServiceApi extends BaseAPI {
  /**
   * 查询菜单数据
   * @summary 查询菜单数据
   * @param {string} [orgId]
   * @param {string} [userId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenuServiceApi
   */
  public menuServiceFindMenu(orgId?: string, userId?: string, options?: RawAxiosRequestConfig) {
    return MenuServiceApiFp(this.configuration)
      .menuServiceFindMenu(orgId, userId, options)
      .then(request => request(this.axios, this.basePath));
  }
}
